module.exports = __webpack_public_path__ + "static/fonts/ibm-plex-mono-v12-latin-300italic.d11a089.woff";